<template>
  <div class="card__info" :class="{ 'card__info--fullwidth': fullWidth }">
    <label v-if="title" v-html="title"></label>
    <div v-if="$slots.default">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: () => '',
  },
  fullWidth: {
    type: Boolean,
    default: () => false,
  },
})
</script>
